import { Reducer } from "redux";

import { SaveReferralLevelNote } from "../models/Api/Notes";
import { SaveReferralLevelNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { SaveReferralLevelNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: SaveReferralLevelNote = {
  loading: false,
  response: {
    referralNoteId: -1,
    referralId: -1,
    noteEntryId: -1,
    dateCreated: "",
    dateUpdated: "",
    userCreated: "",
    noteTemplateId: -1,
    templateName: "",
    noteEntryJson: "",
    comment: "",
    fullNameCreated: "",
    highestCred: null,
  },
};

const SaveReferralLevelNotesReducer: Reducer<
  SaveReferralLevelNote,
  SaveReferralLevelNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SaveReferralLevelNotesActionDispatchTypes.SAVE_REFERRAL_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SaveReferralLevelNotesActionDispatchTypes.SAVE_REFERRAL_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SaveReferralLevelNotesActionDispatchTypes.SAVE_REFERRAL_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SaveReferralLevelNotesReducer;
